export const GALLERY_MAX_FILE_SIZE_BYTES = 10 * 1024 * 1024;
export const GALLERY_FORMATS_LABEL = "JPEG, PNG, WebP, or AVIF";
export const GALLERY_ALLOWED_MIME_TYPES = [
    "image/jpeg",
    "image/jpg",
    "image/png",
    "image/webp",
    "image/avif",
    "image/avif-sequence",
];
export const GALLERY_ALLOWED_EXTENSIONS = ["jpg", "jpeg", "png", "webp", "avif", "avifs"];

const GENERIC_MIME_TYPES = new Set(["", "application/octet-stream"]);

export const isAllowedGalleryFile = (file) => {
    if (!file) return false;

    const ext = file.name?.split(".").pop()?.toLowerCase();
    if (ext && GALLERY_ALLOWED_EXTENSIONS.includes(ext)) {
        return true;
    }

    if (GALLERY_ALLOWED_MIME_TYPES.includes(file.type)) {
        return true;
    }

    if (GENERIC_MIME_TYPES.has(file.type) && ext && GALLERY_ALLOWED_EXTENSIONS.includes(ext)) {
        return true;
    }

    return false;
};

export const validateGalleryFiles = (files) => {
    if (!files?.length) return [];

    const errors = [];
    files.forEach((file, index) => {
        const label = `Photo ${index + 1}${file?.name ? ` (${file.name})` : ""}`;

        if (!isAllowedGalleryFile(file)) {
            errors.push(`${label}: Only ${GALLERY_FORMATS_LABEL} are allowed.`);
            return;
        }

        if (file.size > GALLERY_MAX_FILE_SIZE_BYTES) {
            errors.push(`${label}: Must be 10 MB or smaller.`);
        }
    });

    return errors;
};

export const formatGalleryUploadError = (
    error,
    fallback = "Failed to upload photos. Please try again."
) => {
    const data = error?.response?.data;
    if (!data) return [fallback];

    const fieldErrors = data.errors;
    if (fieldErrors && typeof fieldErrors === "object") {
        const messages = [];
        Object.values(fieldErrors).forEach((value) => {
            const list = Array.isArray(value) ? value : [value];
            list.filter(Boolean).forEach((msg) => messages.push(String(msg)));
        });

        const unique = [...new Set(messages.filter(Boolean))];
        if (unique.length > 0) {
            return unique;
        }
    }

    if (data.message) {
        return [String(data.message)];
    }

    return [fallback];
};
